import ContainsMetadataQuery from './ContainsMetadataQuery.js';
/**
 * @memberof geodata
 * @param {object} [properties]
 * @param {number} [properties.featureClass] - the ID of the feature class
 * @param {number} [properties.pointCount]
 * @param {number} [properties.polygonCount]
 * @param {number} [properties.featureCount]
 */
class FeatureContainsMetadata {
    constructor(props) {
        Object.assign(this, props);
    }
    isValidQuery() {
        return this.polygonCount <= FeatureContainsMetadata.MAX_POLYGONS
            && this.pointCount <= FeatureContainsMetadata.MAX_VERTICES;
    }
    /**
     * @param {GeoJSON.Feature} feature
     * @return {Promise}
     */
    static forFeature(feature) {
        return ContainsMetadataQuery.create(feature).then(mapData);
    }
}
FeatureContainsMetadata.MAX_POLYGONS = 5000;
FeatureContainsMetadata.MAX_VERTICES = 350000;
const resultToCamelCase = function (feature) {
    return new FeatureContainsMetadata({
        featureClass: feature.properties.feature_class,
        polygonCount: feature.properties.polygon_count,
        pointCount: feature.properties.point_count,
        featureCount: feature.properties.feature_count,
    });
};
const mapData = function (data) {
    return data.features.map(resultToCamelCase);
};
export default FeatureContainsMetadata;
